import {Observable} from 'rxjs';
import {BI_ERRORS} from '../../../logging/errors';
import {logError} from '../../../logging/logging';

export function subscribe<T>(observable: Observable<T>, observer?: any) {
  observable.subscribe({
    error: (reason) => {
      logError(BI_ERRORS.genericError, {
        reason,
      });
    },
    next: () => {},
    ...observer,
  });
}
